import { render, staticRenderFns } from "./TurmaDisciplinas.vue?vue&type=template&id=413c6708&"
import script from "./TurmaDisciplinas.vue?vue&type=script&lang=js&"
export * from "./TurmaDisciplinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports